import payroll from './modules/payroll/index.js'
import myself from './modules/myself/index.js'
import myteam from './modules/myteam/index.js'
import organisation from './modules/organisation/index.js'
import overview from './modules/overview/index.js'
import settings from './modules/settings/index.js'
import utilities from './modules/utilities/index.js'
import humanResource from './modules/HumanResource/index.js'
import nps from "./modules/npsVps/nps.js"
import vpf from "./modules/npsVps/vpf.js"
import itProof from "./modules/itProofSubmission/itProof.js"

import hsbcPaymentSetting from "./modules/HSBC/HSBCpaymentSetting.js"
import logsheetManagement from "./modules/logsheet/logManagementFetch.js"
import letterManagement from './modules/letterManagement/letterManagement.js'
export default {
    namespaced: true,
    modules: {
        payroll: payroll,
        myself: myself,
        myteam: myteam,
        organisation: organisation,
        overview: overview,
        settings: settings,
        utilities: utilities,
        humanResource:humanResource,
        nps:nps,
        vpf:vpf,
        itProof:itProof,
        hsbcPaymentSetting:hsbcPaymentSetting,
        logsheetManagement: logsheetManagement,
        letterManagement: letterManagement
    }
};
